import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { forkJoin, Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { BpfBilanFinancier, BpfResume } from 'src/app/models/bpf/bpf-resume.model';
import { ConfigService } from '../config/config.service';

/**
 * Fusionne deux routes de microservices différents : le cadre E/F/G vient de FormationsService
 * (GetResumeBpf), le cadre C vient de FinancierService (GetBilanFinancierBpf). Choix délibéré de
 * ne rien absorber : si l'un des deux appels échoue, tout le résumé échoue (un cadre C
 * silencieusement à 0 € serait recopié tel quel dans la télédéclaration) — la chaîne
 * d'intercepteurs d'erreurs .NET déjà en place s'occupe de l'affichage.
 */
@Injectable({
  providedIn: 'root',
})
export class BpfResumeService {
  constructor(private http: HttpClient, private configService: ConfigService) {}

  /** Plusieurs entités : paramètre idEntite répété (?idEntite=1&idEntite=2), compris par les deux back. */
  getResume(idsEntite: number[], dateDebut: Date, dateFin: Date): Observable<BpfResume> {
    const entites = idsEntite.map((id) => `idEntite=${id}`).join('&');
    const params = `?${entites}&dateDebut=${this.formatDate(dateDebut)}&dateFin=${this.formatDate(dateFin)}`;

    const resume$ = this.http.get<Omit<BpfResume, 'bilanFinancier'>>(
      `${this.configService.config.urlApi}/api/f/bpf/GetResumeBpf${params}`,
    );
    const bilanFinancier$ = this.http.get<BpfBilanFinancier>(
      `${this.configService.config.urlApi}/api/fi/Bpf/GetBilanFinancierBpf${params}`,
    );

    return forkJoin({ resume: resume$, bilanFinancier: bilanFinancier$ }).pipe(
      map(({ resume, bilanFinancier }) => ({ ...resume, bilanFinancier })),
    );
  }

  private formatDate(date: Date): string {
    const y = date.getFullYear();
    const m = (date.getMonth() + 1).toString().padStart(2, '0');
    const d = date.getDate().toString().padStart(2, '0');
    return `${y}-${m}-${d}`;
  }
}
